import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentElement, SelectOption } from '@urbannex/storethemes';
import { InputField } from '../../../model';

@Component({
  selector: 'kve-select-field-editor',
  templateUrl: './select-field-editor.component.html',
  styleUrls: ['./select-field-editor.component.scss']
})
export class SelectFieldEditorComponent implements OnInit {
  @Input() field:InputField;
  @Input() selectedContent:ContentElement;
  selectOptions:SelectOption[];
  selectedOption:SelectOption;
  placeHolder = "Select";

  @Output() updateField:EventEmitter<InputField> = new EventEmitter<InputField>();

  constructor() { }

  ngOnInit(): void {
    if(this.selectedContent != undefined && this.selectedContent.selectOptions != undefined){
      this.selectOptions = this.selectedContent.selectOptions;
    }else if(this.field != undefined && this.field.selectOptions != undefined){
      this.selectOptions = this.field.selectOptions;
    }
    //set the selected option
    if(this.field.value != undefined && this.field.value != null){
      const foundOption = this.selectOptions.find(option => option.key === this.field.value);
      this.selectedOption = foundOption ?? this.selectOptions[0];
    }
  }

  changeContent(e){
    console.log({field:this.field,change:e});
    this.field.value = e.key;
    this.updateField.emit(this.field);
  }

}
